import React from "react";
import {
  SelectInput,
  TextInput,
  CheckBoxInput,
  TextAreaInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import { useState, useEffect } from "react";
import RadioButtonGroup from "./../../components/common/ui/Inputs/RadioInput";
import kiosksSchema from "../../validation/kiosksSchema";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { kiosksActions, masterActions, authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { useRef } from "react";
import { StoredProcedures } from "../../_helpers/enumerator";
import CustomLoader from "../../components/common/ui/Loader.jsx";

function AddKIOSKS() {
  const dispatch = useDispatch();
  const { GetPodList } = useSelector((state) => state.master);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const location = useLocation();
  const { id: KiosksID, ActiveStatus } = location.state || {};
  const {
    kiosksList,
    shuffleStatus,
    KioskInfo,
    addKiosksData,
    updateKiosksData,
  } = useSelector((state) => state.kiosks);
  const [loading, setloading] = useState(false);
  const { Status } = useSelector((state) => state.dropdownOptions);

  const [addKioskData, setAddKioskData] = useState({
    PodID: 0,
    kioskID: KiosksID,
    facilityID: commonFacilityCode,
    kioskCode: "",
    ComputerName: "",
    verificationCode: "",
    ActiveStatus: 0,
    isMaintenanceEnabled: 0,
    RemarkNotes: "",
    createdBy: user?.ManagementUserID,
  });
  const [errorMessage, setErrorMessage] = useState({});
  const isEditMode = KioskInfo?.PodCode ? true : false;

  // Load facility dropdown on component mount
  useEffect(() => {
    const loadFacilities = () => {
      dispatch(
        masterActions?.LoadFacilityDropDown({
          facilityID: 0,
        })
      ).catch((error) => {
        console.error("Error loading facilities:", error);
      });
    };

    loadFacilities();
  }, [dispatch]);

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("KioskList");
    }
  }, [commonFacilityCode]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
      })
    );
  }, []);

  // Generate code on mount
  useEffect(() => {
    if (!KiosksID) {
      const newCode = generateUniqueCode();

      setAddKioskData((prevData) => ({
        ...prevData,
        verificationCode: newCode,
      }));
    }
  }, [!KiosksID]);

  useEffect(() => {
    dispatch(masterActions.GetPODList(commonFacilityCode));
  }, [dispatch]);
  useEffect(() => {
    if (KiosksID) {
      setloading(true);
      dispatch(kiosksActions.GetKioskInfo(KiosksID)).then(() => setloading(false));
    }
  }, [KiosksID]);

  useEffect(() => {
    if (KioskInfo && Object.keys(KioskInfo).length > 0) {
      setAddKioskData({
        ...addKioskData,
        PodID: KioskInfo?.PodID || 0,
        kioskCode: KioskInfo?.KiosksCode || "",
        ComputerName: KioskInfo?.ComputerName || "",
        verificationCode: KioskInfo?.KiosksMacAddress || "",
        ActiveStatus: KioskInfo?.ActiveStatus,
        isMaintenanceEnabled: KioskInfo?.Maintenance,
        RemarkNotes: KioskInfo?.RemarkNotes || "",
      });
    }
  }, [KioskInfo]);


  /// insert response
  useEffect(() => {
    switch (addKiosksData?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.KiosksCPU,
            UserAction: `Created a New Kiosk  (KIOSK Code  ${addKiosksData?.kioskCode
                ? addKiosksData?.kioskCode
                : addKioskData?.kioskCode
              } )`,
          })
        );
        history.navigate("/Admin/KioskList");
        //dispatch(kiosksActions.clearKiosks());
        showToastNotification(
          "Kiosk information saved successfully",
          "success"
        );
        break;
      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        break;
      case -4:
        showToastNotification("Kiosk already exists.", "error");
        break;

      default:
        break;
    }
  }, [addKiosksData]);

  // Code generation setup
  const generatedCodes = new Set();
  let counter = 0;

  function generateUniqueCode() {
    const randomPart = Math.random().toString(36).substring(2, 7).toUpperCase();
    const countPart = (counter++ % 1296)
      .toString(36)
      .padStart(2, "0")
      .toUpperCase();
    const code = randomPart + countPart;

    if (generatedCodes.has(code)) {
      return generateUniqueCode();
    }

    generatedCodes.add(code);
    return code;
  }

  const handleChange = (e, select) => {
    // Handle custom component event where 'e.target' may not exist
    let name, value, checked;

    if (e && e.target) {
      // For standard inputs, checkboxes, etc.
      name = e.target.name;
      value = e.target.value;
      checked = e.target.checked;

      if (name === "kioskCode" || name === "ComputerName") {
        if (value?.trim()?.length > 0) {

          // Field-specific regex rules
          const isValid =
            name === "kioskCode"
              ? /^[a-zA-Z0-9_-]+$/.test(value) // No spaces allowed
              : /^[a-zA-Z0-9 _-]+$/.test(value); // Spaces allowed

          if (isValid) {
            setAddKioskData((prevState) => ({
              ...prevState,
              [name]: value,
            }));
          }
        } else {
          // If input is empty or only spaces
          setAddKioskData((prevState) => ({
            ...prevState,
            [name]: "",
          }));
        }

        return; // Exit for these specific fields
      }

    } else {
      // For third-party dropdowns or components (like SelectInput)
      name = select;
      value = e?.value ?? 0;
    }

    switch (select) {
      case "PodID":
        setAddKioskData((prevState) => ({
          ...prevState,
          [select]: value, // Use value directly for dropdowns
        }));
        break;

      case "isMaintenanceEnabled":
        setAddKioskData((prevState) => ({
          ...prevState,
          [name]: checked ? 1 : 0, // Use checked for checkboxes
        }));
        break;

      case "ActiveStatus":
        setAddKioskData((prevState) => ({
          ...prevState,
          [name]: parseInt(value),
        }));
        break;


      default:
        setAddKioskData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        break;
    }
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));
    // setErrorMessage({});
    // // Remove input error styling
    // const inputErrorElements = document?.querySelectorAll(".input-error");
    // inputErrorElements?.forEach((input) => {
    //   input.classList.remove("input-error");
    // });
  };

  const handleBack = () => {
    const isFromPOD = sessionStorage.getItem("fromPOD") === "true";

    if (isFromPOD) {
      sessionStorage.removeItem("fromPOD");
      // history.navigate("/Admin/PODList/Add");
      history.navigate("/Admin/PODList/Add", {
        state: { id: KioskInfo?.PodID, ActiveStatus: ActiveStatus }, // Pass the ID securely using state
      });
    } else {
      history.navigate("/Admin/KioskList");
    }

    dispatch(kiosksActions.clearKisokInfo());
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = kiosksSchema(addKioskData);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error class if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }
    switch (isEditMode) {
      //update
      case true:
        dispatch(kiosksActions.UpdateKiosk(addKioskData)).then((response) => {
          switch (response?.payload?.IsSucceed) {
            case 1:
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName: StoredProcedures?.KiosksCPU,
                  UserAction: `Updated Kiosk Details  ( KiosksID - ${addKiosksData?.kioskCode
                      ? addKiosksData?.kioskCode
                      : addKioskData?.kioskCode
                    } )`,
                })
              );
              history.navigate("/Admin/KioskList");
              //dispatch(kiosksActions.clearKiosks());
              showToastNotification(
                "Kiosk information updated successfully",
                "success"
              );
              dispatch(kiosksActions.clearKisokInfo());
              break;
            case -1:
              showToastNotification(
                "Something went wrong. Please try again",
                "error"
              );
              break;
            case -4:
              showToastNotification("Kiosk already exists.", "error");
              break;

            default:
              break;
          }

        })
        break;
      // insert
      default:
        dispatch(kiosksActions.CreateKiosk(addKioskData));
        break;
    }
  };

  // add POD - handleBlur validation handled here
  const handleOnBlur = (e) => {
    let { name, value } = e.target;
    // if (submitted) {
    // Perform validation using the schema
    const { error } = kiosksSchema(addKioskData);

    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
    // }
  };

  const handleReset = () => {
    if (isEditMode) {
      dispatch(kiosksActions.GetKioskInfo(KiosksID));
    } else {
      setAddKioskData({
        ...addKioskData,
        PodID: 0,
        kioskCode: "",
        ComputerName: "",
        ActiveStatus: 0,
        isMaintenanceEnabled: 0,
        RemarkNotes: "",
      });
    }

    setErrorMessage({});

    // Remove input error styling
    const inputErrorElements = document?.querySelectorAll(".input-error");
    inputErrorElements?.forEach((input) => {
      input.classList.remove("input-error");
    });
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100 mb-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className=" form_title_uppercase text-color">
            {isEditMode ? "EDIT Kiosk" : "ADD KIOSK"}
          </h2>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <Button
              label="Back"
              type="button"
              className="me-2"
              onClick={handleBack}
              status="primary"
              icon={"fa-solid fa-angle-left"}
            />
          </div>
        </div>

        <div className="mt-3">
          <h4 className="inner-header-bg text-color">
            {" "}
            <i className="fa-solid fa-circle-info me-2"></i>KIOSK INFORMATION{" "}
          </h4>
          <div className="p-1 ">
            <form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <SelectInput
                      name="PodID"
                      label="POD"
                      value={addKioskData.PodID}
                      handleChange={(e) => handleChange(e, "PodID")}
                      required={true}
                      options={GetPodList}
                      isClearable={addKioskData.PodID !== 0}
                      // handleBlur={handleOnBlur}
                      handleBlur={() =>
                        handleOnBlur({ target: { name: "PodID" } })
                      }
                      isDisabled={addKioskData.ActiveStatus === 1}
                      errorMessage={errorMessage}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <TextInput
                      name="kioskCode"
                      label="Code"
                      value={addKioskData.kioskCode}
                      handleChange={handleChange}
                      placeholder="Enter Code"
                      errorMessage={errorMessage}
                      disabled={isEditMode}
                      handleBlur={handleOnBlur}
                      maxLength={10}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <TextInput
                      name="ComputerName"
                      label="Computer Name"
                      value={addKioskData.ComputerName}
                      handleChange={handleChange}
                      placeholder="Enter Computer Name"
                      errorMessage={errorMessage}
                      handleBlur={handleOnBlur}
                      maxLength={20}
                      required={true}
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="form-floating mb-3">
                    <TextInput
                      name="verificationCode"
                      label="Verification Code"
                      value={addKioskData.verificationCode}
                      handleChange={handleChange}
                      errorMessage={errorMessage}
                      disabled={true}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4 mt-2">
                  <div className="form-floating mb-3">
                    <RadioButtonGroup
                      name="ActiveStatus"
                      id="ActiveStatus"
                      label="Status"
                      selectedValue={addKioskData.ActiveStatus}
                      handleChange={(e) => handleChange(e, "ActiveStatus")}
                      options={Status}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4 mt-2">
                  <div className="form-floating mb-3">
                    <CheckBoxInput
                      id="isMaintenanceEnabled"
                      name="isMaintenanceEnabled"
                      label="Maintenance"
                      checked={addKioskData?.isMaintenanceEnabled === 1}
                      handleClick={(e) =>
                        handleChange(e, "isMaintenanceEnabled")
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-floating mb-3">
                    <TextAreaInput
                      name="RemarkNotes"
                      placeholder="Remarks"
                      label="Remarks"
                      rows={6}
                      maxLength={100}
                      value={addKioskData?.RemarkNotes}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                <Button
                  className="me-2"
                  label={isEditMode ? "Update" : "Save"}
                  type="submit"
                  status="success"
                  variant="danger"
                  icon={
                    isEditMode
                      ? "fa-solid fa-pen-to-square"
                      : "fa-solid fa-floppy-disk"
                  }
                  disabled={false}
                />
                <Button
                  className="me-2"
                  label="Reset"
                  type="reset"
                  variant="danger"
                  status={"secondary"}
                  icon={"fa-solid fa-rotate-right"}
                  disabled={false}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(AddKIOSKS);
